/** BRC brand logo (official wordmark). */
export function BrcLogo({ className = 'h-10' }: { className?: string }) {
  return (
    <img
      src="/brc-logo.png"
      alt="BRC"
      className={`w-auto ${className}`}
    />
  );
}
